import { Cell } from '../grid/Cell'
import { BaseModal } from './BaseModal'

type Props = {
  isOpponent: boolean
  isOpen: boolean
  handleClose: () => void
}

export const InfoModal = ({ isOpen, handleClose, isOpponent }: Props) => {
  return (
    <BaseModal title="How to play" isOpen={isOpen} handleClose={handleClose}>
      <p className="text-sm text-gray-500 dark:text-gray-300">
        Guess the word in 6 tries. After each guess, the color of the tiles will
        change to show how close your guess was to the word.
      </p>

      <div className="mb-1 mt-4 flex justify-center">
        <Cell
          isOpponent={isOpponent}
          isRevealing={true}
          isCompleted={true}
          value="W"
          status="correct"
        />
        <Cell isOpponent={isOpponent} value="E" isCompleted={true} />
        <Cell isOpponent={isOpponent} value="A" isCompleted={true} />
        <Cell isOpponent={isOpponent} value="R" isCompleted={true} />
        <Cell isOpponent={isOpponent} value="Y" isCompleted={true} />
      </div>
      <p className="text-sm text-gray-500 dark:text-gray-300">
        The letter W is in the word and in the correct spot.
      </p>

      <div className="mb-1 mt-4 flex justify-center">
        <Cell isOpponent={isOpponent} value="P" isCompleted={true} />
        <Cell isOpponent={isOpponent} value="I" isCompleted={true} />
        <Cell
          isOpponent={isOpponent}
          isRevealing={true}
          isCompleted={true}
          value="L"
          status="present"
        />
        <Cell isOpponent={isOpponent} value="O" isCompleted={true} />
        <Cell isOpponent={isOpponent} value="T" isCompleted={true} />
      </div>
      <p className="text-sm text-gray-500 dark:text-gray-300">
        The letter L is in the word but in the wrong spot.
      </p>

      <div className="mb-1 mt-4 flex justify-center">
        <Cell isOpponent={isOpponent} value="V" isCompleted={true} />
        <Cell isOpponent={isOpponent} value="A" isCompleted={true} />
        <Cell isOpponent={isOpponent} value="G" isCompleted={true} />
        <Cell isOpponent={isOpponent} isRevealing={true} isCompleted={true} value="U" status="absent" />
        <Cell isOpponent={isOpponent} value="E" isCompleted={true} />
      </div>
      <p className="text-sm text-gray-500 dark:text-gray-300">
        The letter U is not in the word in any spot.
      </p>

      <p className="mt-6 text-sm italic text-gray-500 dark:text-gray-300">
        This is an open source version of the word guessing game we all know and
        love -{' '}
        <a
          href="https://github.com/cwackerfuss/react-wordle"
          className="font-bold underline"
        >
          check out the code here
        </a>{' '}
      </p>
    </BaseModal>
  )
}
